const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/contact",
    exact: true,
    component: "Contact",
  },
  {
    path: "/privacy-policy",
    exact: true,
    component: "PrivacyPolicy",
  },
  {
    path: "/driver-sheet",
    exact: true,
    component: "DriverSheet",
  },
];

export const hiddenRoutes: typeof routes = [
  {
    path: "/admin",
    exact: true,
    component: "Admin",
  },
];

export default routes;
